module.exports = "<chart [options]=\"options\"></chart>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/github-repo-charts/github-repo-charts.component.html
// module id = ./src/app/components/github-repo-charts/github-repo-charts.component.html
// module chunks = main